import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import CustomInput from '../custominput/CustomInput';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import EventLabel from '../EventLabel/EventLabel';
import { useStore } from '../../store/Store';

export const PersonPasswordGate = observer(() => {
  const store = useStore();
  // CustomInput also uses the label as the input's aria-label and name, so it must be plain text.
  // The group is loaded by the EventLabels below; until then the label's usual #name# fallback shows.
  const inputLabel = store.eventLabels?.['CMS.PERSONPASSWORDGATE']?.PERSONPASSWORDGATEINPUTLABEL?.value ?? '#PersonPasswordGateInputLabel#';
  const [inputValue, setInputValue] = useState('');
  const [showValidationMsg, setShowValidationMsg] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInput = e => {
    setInputValue(e.target.value);
  };

  const onClick = async () => {
    if (!inputValue || loading) return;
    setLoading(true);
    try {
      const result = await store.verifyPersonPassword(inputValue);
      if (result.success && result.badgeNo) {
        setShowValidationMsg(false);
        const url = new URL(window.location.href);
        url.searchParams.set('badgeNo', result.badgeNo);
        window.location.href = url.toString();
      } else {
        setShowValidationMsg(true);
      }
    } catch {
      setShowValidationMsg(true);
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = e => e.keyCode === 13 && onClick();

  return (
    <Dialog open={true} aria-labelledby="person-password-gate-title">
      <DialogTitle id="person-password-gate-title">
        <EventLabel name="PersonPasswordGateTitle" groupName="CMS.PersonPasswordGate" />
      </DialogTitle>
      <DialogContent>
        <CustomInput
          onChange={handleInput}
          label={inputLabel}
          value={inputValue}
          onKeyDown={onKeyDown}
        />
        {showValidationMsg && (
          <p className="text-red-500">
            <EventLabel name="PersonPasswordGateValidationMsg" groupName="CMS.PersonPasswordGate" />
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClick} color="primary" disabled={loading}>
          <EventLabel name="PersonPasswordGateOk" groupName="CMS.PersonPasswordGate" />
        </Button>
      </DialogActions>
    </Dialog>
  );
});
